import { Coaching } from '@kinomap-dev/ng-ui-lib/core';

export function convertCoachingToCoachingContentTableItem(coaching: Coaching): any {
  return {
    title: { name: coaching.name, thumbnail: coaching.thumbnails.medium },
    sport: coaching.sport,
    duration: coaching.duration,
    level: coaching.difficulty_level,
    sessions: 9999999,
    comments: coaching.comments_count,
    likes: coaching.likes_count,
    labels: ['test', 'my test label', 'is mock'],
    id: coaching.id,
  };
}
